import api from './api';
import { refreshMemberToken } from './tokenRefresh';

const makeRequestWithRetry = async (requestFn) => {
  try {
    return await requestFn();
  } catch (error) {
    if (error.response?.status === 401) {
      // Try to refresh token once
      const newToken = await refreshMemberToken();
      if (newToken) {
        // Retry the request
        return await requestFn();
      }
    }
    throw error;
  }
};



export const memberDashboard = {


  // Get certificate status
  getCertificate: async () => {
    const response = await api.get('/member/certificate', { withCredentials: true });
    return response.data;
  },

  // Generate certificate
  generateCertificate: async (names) => {
    const response = await api.post('/member/certificate/generate', names, { withCredentials: true });
    return response.data;
  },
  // Download certificate
  downloadCertificate: async () => {
    const response = await api.get('/member/certificate/download', {
      responseType: 'blob', // Important for file download
    });
    return response;
  },


  getDashboard: async () => {
    return makeRequestWithRetry(async () => {
      const response = await api.get('/member/dashboard', { withCredentials: true });
      return response.data;
    });
  },

  getClass: async (classId) => {
    return makeRequestWithRetry(async () => {
      const response = await api.get(`/member/class/${classId}`, { withCredentials: true });
      return response.data;
    });
  },

  submitQuiz: async (classId, answers) => {
    return makeRequestWithRetry(async () => {
      const response = await api.post(`/member/class/${classId}/quiz`, { answers }, { withCredentials: true });
      return response.data;
    });
  },

  markCompleted: async (classId) => {
    return makeRequestWithRetry(async () => {
      const response = await api.post(`/member/class/${classId}/complete`, {}, { withCredentials: true });
      return response.data;
    });
  },

  updateProfile: async (profileData) => {
    return makeRequestWithRetry(async () => {
      const response = await api.put('/member/profile', profileData, { withCredentials: true });
      return response.data;
    });
  },

  // Refresh video OTP
  refreshVideoOTP: async (classId) => {
    return makeRequestWithRetry(async () => {
      const response = await api.post(`/member/class/${classId}/refresh-otp`, {}, { withCredentials: true });
      return response.data;
    });
  },
};